import Model from "@/models/Model";

export default class Widget extends Model {

    constructor(config = {}) {
        super('widget', config);
    }
}